import React, { memo, useEffect, useState, useRef } from 'react'
import Modal from 'react-modal'
import { get } from 'lodash'
import api from '../../../api'
import { ErrorModal, SuccessModal } from '..'
import { Button as AntButton, Input, Popconfirm, Select } from 'antd'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
	},
}

const ChangePrice = ({
	getRef = () => {},
	onConfirm = () => {},
	onClose = () => {},
	refetch = () => {},
	executer = [],
}) => {
	const errorRef = useRef()
	const succesRef = useRef()

	const [isOpenModal, setIsOpenModal] = useState(false)
	const [datas, setData] = useState(null)
	const [price, setPrice] = useState('')
	const [percent, setPercent] = useState('')
	const [manager, setManager] = useState('')
	const [loadingBtn, setLoadingBtn] = useState(false)
	const [salesPerson, setSalesPerson] = useState([])

	useEffect(() => {
		const ref = {
			open: (v) => {
				setData(v)
				setPrice(v?.U_ShopfrontPrice)
				setManager(v?.SlpCode)
				setPercent(v?.U_Percent)

				setIsOpenModal(true)
			},
			close: () => setIsOpenModal(false),
		}
		getRef(ref)
	}, [])

	useEffect(() => {
		getSalesPersons()
	}, [])

	const patchPrice = () => {
		setLoadingBtn(true)
		api
			.patch(`PurchaseInvoices(${datas?.DocEntry})`, {
				SalesPersonCode: manager,
				DocumentLines: [
					{
						LineNum: datas?.LineNum,
						U_ShopfrontPrice: parseFloat(price),
						U_Percent: percent,
					},
				],
			})
			.then(() => {
				succesRef.current?.open('Успешно изменена')
				refetch()
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setLoadingBtn(false)
			})
	}

	const getSalesPersons = () => {
		api
			.get(`SalesPersons?$filter=Active eq 'tYES'`, {
				headers: {
					Prefer: 'odata.maxpagesize=1000000',
				},
			})
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setSalesPerson(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(
						JSON.parse(err.response.data),
						'error.message',
						'Не удалось получить серийный номер. Повторите попытку.',
					),
				)
			})
	}

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => setIsOpenModal(false)}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<div className="card">
				<h2 className="font-bold text-xl text-center mb-5">{'Изменить '}</h2>

				<div className="flex flex-col gap-5 items-center justify-center">
					<div className="flex flex-col items-start gap-2">
						<p className="font-semibold">Менеджер</p>
						<Select
							className="w-[200px]"
							value={manager}
							onChange={setManager}
							options={salesPerson.map((v) => ({
								value: v.SalesEmployeeCode,
								label: v.SalesEmployeeName,
							}))}
						/>
					</div>
					<div className="flex flex-col items-start gap-2">
						<p className="font-semibold">Ёмкость</p>
						<Input
							value={percent}
							className="w-[200px]"
							onChange={(e) => setPercent(e.target.value)}
							onWheel={(e) => e.target.blur()}
							type="number"
							suffix="%"
						/>
					</div>
					<div className="flex flex-col items-start gap-2">
						<p className="font-semibold">Цена</p>
						<Input
							value={price}
							className="w-[200px]"
							onChange={(e) => setPrice(e.target.value)}
							onWheel={(e) => e.target.blur()}
							type="number"
							suffix="$"
						/>
					</div>
				</div>
				<div className="flex justify-center gap-5 mt-10">
					<AntButton
						type="primary"
						className="!bg-red-600 h-10"
						onClick={onClose}
					>
						Отменить
					</AntButton>
					<Popconfirm
						title="Изменить покупку?"
						description="Вы уверены, что хотите изменить покупку?"
						okText="Да"
						cancelText="Нет"
						onConfirm={() => {
							patchPrice()
						}}
					>
						<AntButton
							type="primary"
							loading={loadingBtn}
							className="!bg-blue-600 h-10"
						>
							Изменить
						</AntButton>
					</Popconfirm>
				</div>
			</div>

			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
				onConfirm={() => {
					setIsOpenModal(false)
				}}
			/>
			<SuccessModal
				getRef={(r) => {
					succesRef.current = r
				}}
				onConfirm={() => {
					setIsOpenModal(false)
				}}
			/>
		</Modal>
	)
}

export default memo(ChangePrice)
